module.exports = {
      id: "ios-small-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#ios-small",
      toString: function () {
        return this.url;
      }
    }